// extracted by css-extract-rspack-plugin
export default {"icon":"NavLink-module__icon__ltGNM","title":"NavLink-module__title__Q7t0p","label":"NavLink-module__label__bil7n","subtitle":"NavLink-module__subtitle__X4gkW"};